module.exports = __webpack_public_path__ + "static/media/88.78fcb7b7.png";